import React from 'react';
import ShowRejectNotification from './ApplicationReject/ShowRejectNotification';

export default function ApplicationReject(props) {
  const { rejectNotifications, setRejectNotifications } = props;

  return (
    <>
      {rejectNotifications.map((notification, i) => (
        <ShowRejectNotification
          notification={notification}
          rejectNotifications={rejectNotifications}
          key={i}
          setRejectNotifications={setRejectNotifications}
        />
      ))}
    </>
  );
}
